import * as groupBudgetsActions from '../actions/Budgets';

const initialState = {
  status: 200
};

const groupBudgets = (state = initialState, action) => {
  switch (action.type) {
    case groupBudgetsActions.GET_GROUP_BUDGETS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case groupBudgetsActions.GET_GROUP_BUDGETS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default groupBudgets;
